import { userSuscriptionBackground } from '@/Utils/helpers';
import { useCurrentUser } from '@/Utils/stripeHooks/useCurrentUser';
import React from 'react';

const UserImg = ({ logo }) => {
  const { data: user } = useCurrentUser();
  const current_user = user;
  const background = userSuscriptionBackground(
    current_user?.subscription?.plan_name,
  );
  return (
    <div className='pointer'>
      <span className={`${background} w-14 h-14  rounded-full flex box-border`}>
        <img
          className='w-full h-full rounded-full object-cover p-2px box-border'
          src={logo}
          alt='logo'
        />
      </span>
    </div>
  );
};
export default UserImg;
